// Screen.js
import React from 'react';
import Header from '../Header';
import NavigationLinks from '../../navigation/NavigationLinks';
import Footer from '../FooterComponents/Footer';

const MainScreenComponent = ({ title, children }) => {
  const links = NavigationLinks();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header
        title={'LovenCoders'}
        links={links}
      />
      <main style={{ flex: 1 }}>{children}</main>
      <footer style={{ padding: '40px 16px', background: '#111111'}}>
        <Footer links={links} />
      </footer>
    </div>
  );
};

export default MainScreenComponent;
